import { OfferResponse } from 'logic/api-models/api-models';
import getIsTutoringSchool from 'logic/helpers/isTutoringSchool';
import { SubjectsByNumber } from 'logic/store/subject/subject.model';
import { translate, translationKeys } from 'logic/translations/translations.service';

export type GetOfferCardTitle = (
  offer: OfferResponse | undefined,
  subjectsByNumber: SubjectsByNumber | undefined,
  elite?: boolean,
  refugee?: boolean
) => string;

export const getRegularOfferCardTitle: GetOfferCardTitle = (
  offer,
  subjectsByNumber,
  elite,
  refugee
) =>
  getIsTutoringSchool(offer)
    ? getTutoringSchoolOfferCardTitle(offer, subjectsByNumber)
    : refugee
    ? translate(translationKeys.offerListCard.titleRefugees, {
        firstName: offer?.user?.firstName,
      })
    : translate(translationKeys.offerListCard.title, {
        firstName: offer?.user?.firstName,
        subjects: (elite ? offer?.elitetutor?.approvedSubjects : offer?.subjects)
          ?.map((subjectNumber) =>
            subjectsByNumber ? subjectsByNumber[subjectNumber as any]?.subjectName : subjectNumber
          )
          .join(', '),
      });

export const getTutoringSchoolOfferCardTitle: GetOfferCardTitle = (offer) =>
  `${offer?.tutoringSchool?.name || ''} ${offer?.location?.place || ''}`;
